import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ScoreTeaser from "@/pages/ScoreTeaser";
import Dashboard from "@/pages/Dashboard";
import GapAnalysis from "@/pages/GapAnalysis";
import Policies from "@/pages/Policies";
import Evidence from "@/pages/Evidence";
import Outreach from "@/pages/Outreach";
import Analytics from "@/pages/Analytics";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/score" element={<ScoreTeaser />} />
        <Route path="/app" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
        <Route path="/app/gap" element={<ProtectedRoute><Layout><GapAnalysis /></Layout></ProtectedRoute>} />
        <Route path="/app/policies" element={<ProtectedRoute><Layout><Policies /></Layout></ProtectedRoute>} />
        <Route path="/app/evidence" element={<ProtectedRoute><Layout><Evidence /></Layout></ProtectedRoute>} />
        <Route path="/app/outreach" element={<ProtectedRoute><Layout><Outreach /></Layout></ProtectedRoute>} />
        <Route path="/app/analytics" element={<ProtectedRoute><Layout><Analytics /></Layout></ProtectedRoute>} />
        <Route path="/app/billing" element={<ProtectedRoute><Layout><Billing /></Layout></ProtectedRoute>} />
        <Route path="/app/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

export default App;
